module.exports = __webpack_public_path__ + "img/06戴博涛.6538f9f5.jpg";